import { Component, Input } from "@angular/core";
import { Product, Question } from "../service/membership-application/membership-application";
import { MembershipApplicationService } from "../service/membership-application/membership-application.service";
import { termsSimpleText } from "../terms/terms.component";

@Component({
  selector: 'app-apply',
  templateUrl: 'apply.component.html',
  styleUrls: ['apply.component.scss'],
  providers: [MembershipApplicationService]
})
export class ApplyComponent {
  message: string;
  questions: Question[];
  products: Product[];
  terms: string;

  constructor(private applicationService: MembershipApplicationService) {
    // this.terms = '<h4>이용안내</h4>' + termsText + '<h4>개인정보보호정책</h4>' + privacyText;
    this.terms = termsSimpleText;

    this.applicationService.getQuestions().subscribe(
      res => this.questions = res
    )

    this.applicationService.getProducts().subscribe(
      res => {
        this.products = res.products
        this.message = res.message
      }
    )
  }

  onNumberCheck(phone: string) {
    return phone.replace(/[^0-9\.]+/g, '');
  }

  private _email;
  private email_provider = [
    '@naver.com',
    '@gmail.com',
    '@hanmail.com',
    '@Hotmail.com',
    '@nate.com',
    '@yahoo.com',
  ]
  email_list: string[] = []
  get email(): string { return this._email; }
  @Input()
  set email(val: string) {
    this._email = val;
    if (val.length && val.split('@').length === 1) {
      this.email_list = this.email_provider.map(o => val + o)
    } else {
      this.email_list = []
    }
  }
  onClickEmailItem(item) {
    this.email = item;
  }


  selectedDate: string;
  termEtc: string;

  onSelectedDate(date: string) {
    this.selectedDate = date;
  }

  selectedProducts: any[] = [];
  onSelectProduct(index: number, checked: boolean) {
    this.selectedProducts[index] = (checked) ? this.products[index] : '';
  }

  /** 투어신청 완료시 */
  application: any;
  complete: boolean = false;
  agree: boolean = false;

  getOffsetTop(el): number { var top = 0; if (el.offsetParent) { do { top += el.offsetTop; } while (el = el.offsetParent); return top; } }

  onApply(application: any) {

    if (application['confirm'] != 'Y') {
      window.scrollTo(0, -350 + this.getOffsetTop(document.getElementsByName('confirm')[0]));
      window.alert('헤이그라운드 문화에 동의하셔야 신청가능합니다.');
      return;
    }

    window.open('https://docs.google.com/forms/d/e/1FAIpQLSeOPsiMHfOpdZbMwB4OXRJpfzE2GOQkaP2MT-vH-BxGw6aHOA/viewform', '_blank');

    // application.phone = this.onNumberCheck(application.phone);
    // application.date = this.selectedDate;
    // application.immediately = !!application.immediately;
    // if (application.term == '기타') application.term = this.termEtc;
    // this.selectedProducts = this.selectedProducts.filter(value => value != '')
    // application.productName = this.selectedProducts.map(o => `[${o.location}] ${o.name}`).join(', ')

    // if (!application.company) {
    //   window.scrollTo(0, -200 + this.getOffsetTop(document.getElementsByName('company')[0]));
    //   window.alert('이름 또는 법인명을 입력해주세요.');
    //   return;
    // } else if (!application.name) {
    //   window.scrollTo(0, -200 + this.getOffsetTop(document.getElementsByName('name')[0]));
    //   window.alert('담당자 이름을 입력해주세요.');
    //   return;
    // } else if (!application.phone) {
    //   window.scrollTo(0, -200 + this.getOffsetTop(document.getElementsByName('phone')[0]));
    //   window.alert('담당자 전화번호를 입력해주세요.');
    //   return;
    // } else if (!application.email) {
    //   window.scrollTo(0, -200 + this.getOffsetTop(document.getElementsByName('email')[0]));
    //   window.alert('담당자 이메일 주소를 입력해주세요.');
    //   return;
    // } else if (!application.numbers) {
    //   window.scrollTo(0, -200 + this.getOffsetTop(document.getElementsByName('numbers')[0]));
    //   window.alert('입주희망인원을 입력해주세요.');
    //   return;
    // } else if (!application.productName) {
    //   window.scrollTo(0, -200 + this.getOffsetTop(document.getElementById('frm-product')));
    //   window.alert('입주 희망 공간을 선택해주세요.');
    //   return;
    // } else if (!application.term) {
    //   window.scrollTo(0, -200 + this.getOffsetTop(document.getElementsByName('term')[0]));
    //   window.alert('희망입주기간을 입력해주세요.');
    //   return;
    // } else if (!application.date) {
    //   window.scrollTo(0, -200 + this.getOffsetTop(document.getElementById('frm-date')));
    //   window.alert('입주희망시점을 입력해주세요.');
    //   return;
    // } else if (!this.agree) {
    //   window.alert('약관 및 개인정보정책에 동의해 주세요.');
    //   return;
    // }

    // //make input params
    // let ipt = { ...application }
    // delete ipt.confirm
    // ipt.status = "APPLICATION"
    // ipt.answer = {}
    // ipt.location = []

    // if (application.productName.indexOf('성수 시작점') !== -1) ipt.location.push('seongsu')
    // if (application.productName.indexOf('서울숲점') !== -1) ipt.location.push('seoulsoop')

    // ipt.location = ipt.location.join(',')

    // for (let i = 0; i < this.questions.length; i++) {
    //   let o = this.questions[i]

    //   if (o.notnull_yn === 'Y' && application[o.cd].length === 0) {
    //     window.scrollTo(0, -200 + this.getOffsetTop(document.getElementById(o.cd)));
    //     window.alert('정보를 입력해주세요.');
    //     return;
    //   }

    //   delete ipt[o.cd]
    //   ipt.answer[o.cd] = application[o.cd]
    // }

    // this.applicationService.apply(ipt).subscribe(
    //   application => {
    //     this.application = ipt;
    //     this.complete = true;
    //   }
    // );
  }

  onCheckLength(content: string): boolean {
    if (content.length > 1000) {
      window.alert('최대 1000자 까지 작성가능합니다.');
      return false;
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/apply/apply.component.ts